import React, { useState } from "react";
import { auth, db, storage } from "../firebase-config";
import { signOut } from "firebase/auth";

import { doc, updateDoc, serverTimestamp } from "firebase/firestore";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import Cookies from "universal-cookie";
import { FileUploader } from "./FileUploader";
import LinkToGoogle from "./LinkToGoogle";

const cookies = new Cookies();

const EditUser = ({ setShowUserModal, userObj, placeholderAvatar }) => {
  const [jukeboxUserObj, setJukeboxUserObj] = useState(userObj);
  const [fileName, setFileName] = useState("");
  const [avatarImage, setAvatarImage] = useState(userObj.photoURL);
  // State to store uploaded file
  const [file, setFile] = useState("");

  // progress
  const [percent, setPercent] = useState(0);

  const handleFile = (file) => {
    setFileName(file.name);
    if (!file) {
      alert("Please upload an image first!");
    }

    const storageRef = ref(
      storage,
      `muuzbox/channels/${auth.currentUser.uid}/${file.name}`
    );

    // progress can be paused and resumed. It also exposes progress updates.
    // Receives the storage reference and the file to upload.
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const percent = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );

        // update progress
        setPercent(percent);
      },
      (err) => console.log(err),
      () => {
        // download url
        getDownloadURL(uploadTask.snapshot.ref).then((url) => {
          setAvatarImage(url);
        });
      }
    );
  };

  const handleUpload = () => {
    if (!file) {
      alert("Please upload an image first!");
    }

    const storageRef = ref(
      storage,
      `muuzbox/channels/${auth.currentUser.uid}/${file.name}`
    );

    // progress can be paused and resumed. It also exposes progress updates.
    // Receives the storage reference and the file to upload.
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const percent = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );

        // update progress
        setPercent(percent);
      },
      (err) => console.log(err),
      () => {
        // download url
        getDownloadURL(uploadTask.snapshot.ref).then((url) => {});
      }
    );
  };

  const handleEditUser = async (e) => {
    const newObj = jukeboxUserObj;

    e.target.name === "bio"
      ? (newObj.bio = e.target.value)
      : e.target.name === "newdisplayname"
      ? (newObj.displayName = e.target.value)
      : (newObj.photoURL = avatarImage);
    setJukeboxUserObj(newObj);

    setTimeout(() => {}, 500);
  };

  const handleEditUserSave = (e) => {
    const ref = doc(db, `users`, auth.currentUser.uid);
    updateDoc(ref, {
      displayName: jukeboxUserObj.displayName,
      photoURL: avatarImage,
      bio: jukeboxUserObj.bio || "",
      nameChanged: true,
      updatedAt: serverTimestamp(),
    });
  };

  const logout = async (e) => {
    await signOut(auth)
      .then(() => {
        // Sign-out successful.
        e.preventDefault();
        console.log("signed out");
        cookies.remove("auth-token");
      })
      .catch((error) => {
        // An error happened.
        console.log("sign out error", error);
      });
  };

  return (
    <div className="bg-white text-black divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700 muuz-edituser-panel">
      <div>
        <div className="flex justify-between text-white">
          <div>&npsp;</div>
          <div className="text-black font-black">
            <h1>USER SETTINGS</h1>
          </div>
          <button
            onClick={() => {
              setShowUserModal(false);
            }}
            className="block text-center flex justify-end px-4 py-2 text-black hover:bg-gray-600 dark:hover:bg-gray-600 dark:hover:text-white"
          >
            <div>X</div>
          </button>
        </div>

        <hr className="mt-4" />

        <div className="flex justify-between">
          <LinkToGoogle />
        </div>

        {/* <button onClick={logout}>logout</button> */}
        <hr className="mt-4" />
        <div className="flex flex-wrap justify-center-safe">
          <div className="w-full lg:w-1/2">
            <h3 className="mb-2 font-black">{userObj.displayName}</h3>

            <div className="flex justify-center h-[100px] w-[100px] bg-black m-auto rounded-full border overflow-hidden text-center items-center cursor-pointer">
              <img
                src={avatarImage ? avatarImage : placeholderAvatar}
                alt="channel avatar"
                className="w-full justify-self-center"
              />
            </div>

            <div className="flex justify-center w-full m-auto">
              <FileUploader handleFile={handleFile} user={true} />

              <div>
                {fileName ? <div>Uploaded file: {fileName}</div> : null}

                {percent > 0 && <div>{percent} "% done"</div>}
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-left w-full lg:w-1/2">
            <div className="mt-8">
              <input
                placeholder={userObj.displayName}
                type="text"
                name="newdisplayname"
                id="newdisplayname"
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleEditUser(e);
                }}
                onChange={handleEditUser}
                className="flex text-gray-800 dark:text-gray-800 border rounded-xl focus:outline-none focus:border-indigo-300 pl-4 h-20   mt-2 mb-2"
              />
            </div>

            <textarea
              placeholder={jukeboxUserObj.bio}
              className="flex text-gray-800 dark:text-gray-800 border rounded-xl focus:outline-none focus:border-indigo-300 pl-4 pt-4 pr-4 h-40  mt-2 mb-2"
              onChange={handleEditUser}
              name="bio"
            />
          </div>
        </div>
        <hr className="mt-8" />

        <button
          onClick={(e) => {
            handleEditUserSave(e);
            setShowUserModal(false);
            setTimeout(() => {
              window.location.reload();
            }, 500);
          }}
          className="flex items-center justify-center bg-indigo-500 hover:bg-indigo-600 rounded-xl text-white px-4 py-1  w-100 h-12 mt-4 mr-2"
        >
          <span className="ml-0">
            <svg
              className="w-8 h-8 -mt-px text-white"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4 6C4 4.89543 4.89543 4 6 4H12H14.1716C14.702 4 15.2107 4.21071 15.5858 4.58579L19.4142 8.41421C19.7893 8.78929 20 9.29799 20 9.82843V12V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V6Z"
                stroke="#ffffff"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8 4H13V7C13 7.55228 12.5523 8 12 8H9C8.44772 8 8 7.55228 8 7V4Z"
                stroke="#ffffff"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7 15C7 13.8954 7.89543 13 9 13H15C16.1046 13 17 13.8954 17 15V20H7V15Z"
                stroke="#ffffff"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <span className="text-sm font-black">UPDATE YOUR DETAILS</span>
        </button>
      </div>
    </div>
  );
};

export default EditUser;
